export function clonePath(path) {
    return path.map(function (x) { return (Array.isArray(x) ? [].concat(x) : x); });
}
//# sourceMappingURL=clone-path.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/path/process/clone-path.js
// module id = null
// module chunks = 